import { useArePeopleVisible } from "@/hooks/useArePeopleVisible";

/**
 * Whether this chat offers the people search (#668): people found by their
 * role, in a table beside the conversation.
 *
 * One answer for everything that depends on it — the flag sent with each
 * message, which decides whether the API registers the people tools, and the
 * composer's placeholder and the mode's help text, which promise people only
 * when that flag is on. Read anywhere else, the composer would promise people
 * the server never searches.
 *
 * It takes a team that sees its key contacts and a conversation that is not
 * about one company, which is about that company alone. A phone gets it too:
 * it has no room for the table, so its people open as contact cards in a
 * sheet (`ChatPeopleCardsSheet`). The API reads the team's switch again on
 * its side: this can only narrow what it offers.
 */
export function useIsPeopleSearchOffered({
  isCompanyTargeted,
}: {
  readonly isCompanyTargeted: boolean;
}): boolean {
  const arePeopleVisible = useArePeopleVisible();
  return arePeopleVisible && !isCompanyTargeted;
}
